import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { addFlashMessage } from '../../redux/actions'
import { modules as modulesResource } from '../../redux/actions/resource'
import { getCurrentRole, getProfile } from '../../redux/reducers'
import useSortableOrder from '../../components/drag-and-drop/useSortableOrder'

// Drag and drop order of field modules. The module list uses the project-wide
// order (sortOrder); the page of a central module has its own, independent
// order (centralModuleSortOrder). `fieldModules` must be sorted accordingly.
const useFieldModuleOrder = ({
  fieldModules,
  projectId,
  centralModule = false,
  disabled = false,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // Same users as WateringModulePolicy#update?
  const profile = useSelector(getProfile)
  const role = useSelector(getCurrentRole)
  const canReorder = Boolean(
    profile?.admin || profile?.tenantAdmin || role === 'admin'
  )

  const { isSaving, onDragEnd, orderedIds } = useSortableOrder({
    items: fieldModules,
    updatePosition: (moduleId, position) =>
      dispatch(
        modulesResource.update(
          moduleId,
          {},
          centralModule
            ? { central_module_sort_order: position }
            : { sort_order: position }
        )
      ).promise,
    reload: () => dispatch(modulesResource.list({ projectId })),
    onError: () =>
      dispatch(addFlashMessage('Fehler', t('errors:module.couldNotReorder'))),
    disabled,
  })

  const orderedFieldModules = orderedIds
    .map((moduleId) =>
      fieldModules.find(({ id }) => String(id) === String(moduleId))
    )
    .filter(Boolean)

  return { canReorder, isSaving, onDragEnd, orderedFieldModules }
}

export default useFieldModuleOrder
